export const SERVER_URL = `${process.env.REACT_APP_URLBASEAPI ?? '/api'}`;
